export const closeMenu = (): void => {
  const checkbox = document.getElementById('burger-toggle') as HTMLInputElement;
  if (checkbox) checkbox.checked = false;
};

export const getNavigatePath = (hasModule: boolean | null, path: string): string => {
  return hasModule ? path : `suscripcion/${path}`;
};
